import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPropertyAmenityPitch.ts
var t = () => e("propertyAmenityPitch");
//#endregion
export { t as useTrPropertyAmenityPitch };
